// extracted by mini-css-extract-plugin
export default {"modalDialog":"CommandModal_modalDialog__gkF8q","totalCount":"CommandModal_totalCount__MlqLB"};